import { render } from "./glob-xpanel.vue?vue&type=template&id=56357ab4"
import script from "./glob-xpanel.vue?vue&type=script&lang=js"
export * from "./glob-xpanel.vue?vue&type=script&lang=js"

import "./glob-xpanel.vue?vue&type=style&index=0&id=56357ab4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__